import { useGetGeoLocations } from '../amendment.slice';

export function useGeoLocationsLovs() {
  const { data } = useGetGeoLocations();

  const items = data?.production?.getGeoLocations ?? [];

  const geoOptions: Record<string, string> = items.reduce(
    (acc: Record<string, string>, it: any) => {
      if (it?.id && it?.title) acc[it.id] = it.title;

      return acc;
    },
    {}
  );

  return geoOptions;
}
